<template>
  <v-app>
    <v-snackbar v-model="installAlert" color="primary" top timeout="10000">
      Install App?

      <template v-slot:action="{ attrs }">
        <v-btn
          small
          depressed
          color="white primary--text"
          class="mr-2"
          v-bind="attrs"
          @click="installer()"
        >
          Install
        </v-btn>
        <v-btn
          small
          depressed
          color="white"
          outlined
          v-bind="attrs"
          @click="installAlert = false"
        >
          Cancel
        </v-btn>
      </template>
    </v-snackbar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "App",

  data: () => ({
    installer: undefined,
    installAlert: false,
  }),

  created() {
    let installPrompt;
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      installPrompt = e;
      this.installAlert = true;
    });
    this.installer = () => {
      this.installAlert = false;
      installPrompt.prompt();
      installPrompt.userChoice.then((result) => {
        if (result.outcome === "accepted") {
          console.log("Install accepted!");
        } else {
          console.log("Install denied!");
        }
      });
    };
  },

  computed: {
    isLoggedIn() {
      return this.$store.getters.getAuthStatus;
    },
  },

  watch: {
    isLoggedIn(val) {
      if (val) {
        this.connectToCable();
      }
    },
  },

  mounted() {
    if (this.isLoggedIn) this.connectToCable();
  },

  methods: {
    ...mapActions(["updateCollection"]),

    connectToCable() {
      if (localStorage.getItem("lgn") !== "lgn") return;

      const url = process.env.VUE_APP_ACTION_CABLE_URL;
      const tkn = localStorage.getItem("tkn");
      this.$cable.connection.connect(url + "?token=" + tkn);
      this.$cable.subscribe({
        channel: "AdminChannel",
      });
    },
  },

  channels: {
    AdminChannel: {
      received(event) {
        const { data } = event;
        const pollId = this.$route.params.id;

        for (const d in data) {
          // voters
          if (d == "voters" && data[d].poll_id == pollId) {
            this.updateCollection({
              cn: d,
              mode: "push",
              data: data[d],
            });
          } else if (d == "analytics" && data[d][d].id == pollId) {
            // analytics
            this.updateCollection({
              cn: d,
              data: data[d],
            });
          } else {
            // otherwise
            if (data[d].poll_id == pollId || data[d].id == pollId) {
              this.updateCollection({
                cn: d,
                data: data[d],
              });
            }
          }
        }
      },
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=ABeeZee&family=IBM+Plex+Sans:wght@100;300;400;500;600;700&display=swap");

* {
  font-family: "ABeeZee", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body {
  overflow-x: hidden;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "IBM Plex Sans", sans-serif;
}

a {
  text-decoration: none;
}
</style>
